<template>
	<section class="detail-panel"><slot></slot></section>
</template>

<script>
export default {
	name: 'detail-panel'
}
</script>

<style scoped>
.detail-panel {
}
</style>


// WEBPACK FOOTER //
// src/modules/ui/DetailPanel.vue